import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { OptOutOfCampaignRPC } from "./optOutOfCampaignRPC";

export class OptOutOfCampaignRPCClientImpl extends OptOutOfCampaignRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: OptOutOfCampaignRPC.Request): Promise<LeoRPCResult<OptOutOfCampaignRPC.Response, OptOutOfCampaignRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/OptOutOfCampaign",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      OptOutOfCampaignRPC.ResponseDTO,
      OptOutOfCampaignRPC.Errors.ErrorsDTO,
      OptOutOfCampaignRPC.Response,
      OptOutOfCampaignRPC.Errors.Errors
    >(
      response,
      "email-cycle/OptOutOfCampaign",
      OptOutOfCampaignRPC.Response.fromDTO,
      OptOutOfCampaignRPC.Errors.fromDTO
    );
  }
}
